import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronRightIcon, GiftIcon } from 'lucide-react';
import { Eyebrow, Section } from '../ui/Section';
type Bonus = {
  number: number;
  title: string;
  text: string;
  image: string;
  alt: string;
};
const bonuses: Bonus[] = [{
  number: 1,
  title: 'Ficha de diagnóstico',
  text: 'Registro imprimible antes de cada servicio.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a9b6cb3f-ec0e-4224-9469-37537bcc0a0b.jpg',
  alt: 'Ficha de diagnóstico de colorimetría'
}, {
  number: 2,
  title: 'Paleta rápida',
  text: 'Consulta por subtono y estación.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6aa13183-338d-414f-a29e-46fa19688270.jpg',
  alt: 'Paleta cromática de referencia rápida'
}, {
  number: 3,
  title: 'Círculo cromático',
  text: 'Círculo cromático imprimible.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/870333d3-1aab-4aab-8b0a-7fc3a5d26993.jpg',
  alt: 'Círculo cromático imprimible'
}, {
  number: 4,
  title: 'Casos reales',
  text: '6 diagnósticos paso a paso.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bafa31b1-b9e5-432a-add7-7ca71a7abb88.jpg',
  alt: 'Cuaderno con casos de estudio de colorimetría'
}, {
  number: 5,
  title: 'Checklist',
  text: 'Revisión rápida antes de maquillar.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6dcc42da-f192-41c2-bdc0-aa4c3d6ee762.jpg',
  alt: 'Checklist profesional de maquillaje'
}, {
  number: 6,
  title: 'Cuaderno de práctica',
  text: 'Tu archivo de diagnósticos.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7186e46b-5323-43f4-b2dd-d6c22a0b8e5f.jpg',
  alt: 'Cuaderno de práctica de clientas'
}];
export function Bonos() {
  const [selected, setSelected] = useState(0);
  const bonus = bonuses[selected];
  return <Section className="bg-cream" data-id="element-32" data-mp="25nyjxwbahwzk">
      <div className="mx-auto max-w-3xl" data-id="element-33" data-mp="25n6wx9vrd7kw">
        <div className="text-center" data-id="element-34" data-mp="25q2yd86teee3">
          <Eyebrow data-id="element-35" data-mp="21neoqyaa13g2">Incluidos gratis</Eyebrow>
          <h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:mt-3 sm:text-4xl" data-id="element-36" data-mp="21md90gibfss0">6 Bonos Estratégicos</h2>
          <p className="mt-2 text-sm text-plum" data-id="element-37" data-mp="2ankz4baohnb0">Sin costo extra en ambas ofertas.</p>
        </div>

        <div className="mt-6 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-rosegold/10 sm:mt-8 sm:rounded-3xl" data-id="element-38" data-mp="1mxh60xv495y9">
          {bonuses.map((item, index) => {
          const isSelected = selected === index;
          return <button key={item.number} type="button" onClick={() => setSelected(index)} aria-pressed={isSelected} className={`flex w-full items-center gap-3 border-b border-blush px-3 py-2.5 text-left transition-colors last:border-b-0 sm:gap-4 sm:px-5 sm:py-3.5 ${isSelected ? 'bg-blush/70' : 'bg-white hover:bg-cream'}`} data-id="element-39" data-mp="1wobri00jg1in" data-mpi={index}>
                <img src={item.image} alt={item.alt} loading="lazy" decoding="async" sizes="64px" className="h-12 w-12 shrink-0 rounded-lg object-cover sm:h-14 sm:w-14 sm:rounded-xl" data-id="element-40" data-mp="3flydu329ev8y" />
                <span className="min-w-0 flex-1" data-id="element-41" data-mp="3tlhlkur5s4kq">
                  <span className="block text-[9px] font-bold uppercase tracking-wider text-rosegold sm:text-[10px]" data-id="element-42" data-mp="3tmspqvoinecd">BONUS {item.number}</span>
                  <span className="mt-0.5 block font-display text-base font-semibold leading-tight text-ink sm:text-lg" data-id="element-43" data-mp="3klufhvnhialc">{item.title}</span>
                </span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors sm:h-8 sm:w-8 ${isSelected ? 'bg-ink text-cream' : 'bg-blush text-rosegold'}`} data-id="element-44" data-mp="3pmig991im5sr">
                  <ChevronRightIcon className={`h-4 w-4 transition-transform ${isSelected ? 'rotate-90' : ''}`} data-id="element-45" data-mp="2e35yzgazsgc6" />
                </span>
              </button>;
        })}
        </div>

        <AnimatePresence mode="wait" data-id="element-46" data-mp="2omukoyedapsp">
          <motion.div key={bonus.number} initial={{
          opacity: 0,
          y: 7
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -7
        }} transition={{
          duration: 0.2
        }} className="mx-auto mt-3 flex max-w-3xl items-center gap-3 rounded-xl bg-ink px-4 py-3 text-cream sm:mt-4 sm:px-5" data-id="element-47" data-mp="2jot2eformuia">
            <GiftIcon className="h-4 w-4 shrink-0 text-rose" data-id="element-48" data-mp="37ckhfr1oxln9" />
            <p className="text-xs leading-relaxed text-cream/85 sm:text-sm" data-id="element-49" data-mp="33c0lurwrmq38">
              <span className="font-semibold text-rose" data-id="element-50" data-mp="2yeiakuv9zys2">BONUS {bonus.number} — </span>{bonus.text}
            </p>
          </motion.div>
        </AnimatePresence>

        <div className="mx-auto mt-4 max-w-md rounded-xl bg-ink px-5 py-3 text-center sm:mt-6 sm:rounded-2xl sm:px-6 sm:py-4" data-id="element-51" data-mp="1rvtswc71ryhb">
          <p className="text-[9px] uppercase tracking-luxe text-rose sm:text-xs" data-id="element-52" data-mp="2h19nx162y9m">Valor total</p>
          <p className="mt-1 font-display text-2xl font-semibold text-cream sm:text-3xl" data-id="element-53" data-mp="7fm93u8lhdx0"><span className="line-through opacity-50" data-id="element-54" data-mp="7dhw8mspx4kl">$45.000</span> <span className="text-rose" data-id="element-55" data-mp="bgegsj1tjar6">GRATIS</span></p>
        </div>
      </div>
    </Section>;
}